﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:OvertimeController
 * @description
 * # OvertimeController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('CalendarController', ['$scope', 'NtmCalendar', '$routeParams', function ($scope, NtmCalendar, $routeParams) {

      $scope.calendar = new NtmCalendar($routeParams.id);
  }]);